var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5678 16.6296C14.0635 17.5322 11.7903 18.2676 8.88193 18.2676C3.36613 18.2676 0.0566406 14.4567 0.0566406 9.44241C0.0566406 4.42808 3.53327 0.617188 8.54764 0.617188C13.562 0.617188 17.0386 4.42808 17.0386 9.44241C17.0386 10.1778 17.0052 10.5456 16.9384 11.0136H4.56957C4.80358 12.5847 6.57532 14.1559 9.14937 14.1559C11.4894 14.1559 13.6289 13.5542 15.0998 12.6516H15.5678V16.6296ZM12.4589 7.33639C12.158 5.83209 10.5868 4.62865 8.54764 4.62865C6.50846 4.62865 5.10444 5.76524 4.56957 7.33639H12.4589Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.6170785fd610ba96e02824faf25f4535.svg";
export { ForwardRef as ReactComponent };